export default {
    ordersLayout: {
        back: "Quay lại",
        emptyOrders: "Bạn chưa có đơn hàng nào.",
        loading: "Đang tải",
        storeLabel: "Cửa hàng",
        totalLabel: "Tổng cộng",
        storeAddressPending: "Địa chỉ sẽ sớm được cập nhật",
        productNameFallback: "Sản phẩm",
        ecListTitle: "Đơn hàng của bạn",
        ecStatusInStore: "Trạng thái: mua tại cửa hàng",
        ecOrderNumber: "Mã đơn hàng: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} sản phẩm: tổng {{amount}}",
        ecCountTotalOther: "{{count}} sản phẩm: tổng {{amount}}",
        ecViewOrder: "Xem đơn hàng >",
        ecViewOrderA11y: "Xem đơn hàng {{order_number}}",
        ecBackToOrders: "Quay lại đơn hàng của bạn",
        ecInStoreDate: "Mua tại cửa hàng – {{date}}",
        ecProductsOne: "Sản phẩm",
        ecProductsOther: "Sản phẩm",
        ecSku: "Mã SP: {{sku}}",
        ecQty: "Số lượng: {{qty}}",
        ecWarrantyExpired: "Hết hạn bảo hành",
        ecWarrantyActive: "Còn bảo hành",
        ecSubtotalOne: "Tạm tính – {{count}} sản phẩm",
        ecSubtotalOther: "Tạm tính – {{count}} sản phẩm",
    }
}



// WEBPACK FOOTER //
// ./src/locales/vi/index.js